(function () {
    'use strict';

    angular
        .module('components.filters', [
            'utils'
        ]
      );
})();